import { useState, useEffect } from 'react';
import { ReclaimProofRequest } from '@reclaimprotocol/js-sdk';

function HomePage() {
  const [requestUrl, setRequestUrl] = useState('');
  const [proofs, setProofs] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState('');

  // Detect if user is on mobile device
  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      setIsMobile(mobileRegex.test(userAgent.toLowerCase()));
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const getVerificationReq = async () => {
    const APP_ID = '0x2FE977A79f7862CB354AeCa761AFceBD2F6E1c43';
    const APP_SECRET = '0x944fbf75a69825bb7c847e2c1abf8b7b04cedb805f67bb72e60f6c75bb959c39';
    const PROVIDER_ID = 'example';

    try {
      // Initialize the Reclaim SDK with your credentials
      const reclaimProofRequest = await ReclaimProofRequest.init(APP_ID, APP_SECRET, PROVIDER_ID);

      // Generate the verification request URL and set it with local base
     const url = await reclaimProofRequest.getRequestUrl()
 
      // Even if there is a CORS error, just get the request URL from it
        // copy to the clipboard after /verify
    // window.navigator.clipboard.writeText(url?.split('/verify')[1])
      setRequestUrl(url)

      // Start listening for proof submissions
      await reclaimProofRequest.startSession({
        // Called when the user successfully completes the verification
        onSuccess: (proofs) => {
          // Add your success logic here, such as:
          // - Updating UI to show verification success
          // - Storing verification status
          // - Redirecting to another page
          setProofs(proofs);
        },
        // Called if there's an error during verification
        onError: (error) => {
          console.error('Verification failed', error);

          // Add your error handling logic here, such as:
          // - Showing error message to user
          // - Resetting verification state
          // - Offering retry options
        },
      });
    } catch (error) {
      console.error('Error initializing Reclaim:', error);
    }
  };

  const generateQRCode = async () => {
    if (!requestUrl) return;
    
    try {
         const template = requestUrl.split('/verify/?template=')[1]
      const finalUrl = `${window.location.origin}/verify/?template=${template}`
      // For desktop, generate QR code using a QR API
      const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(finalUrl)}`;
      setQrCodeUrl(qrApiUrl);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  const handleMobileCTA = () => {
    if (requestUrl) {
      // For mobile, open the request URL directly
      // https://share.reclaimprotocol.org/verify/?template=%7B%22sessionId%22%3A%22201cf943f0%22%2C%22providerId%22%3A%22example%22%2C%22applicationId%22%3A%220x2FE977A79f7862CB354AeCa761AFceBD2F6E1c43%22%2C%22signature%22%3A%220x25759ad60456c8000f9d648f4665d24d8a28a628ee791bfbab17cc3d721f79c810d107b0b09a4d60672c3deb29682f20738c58f6b6d1038239f7333beab4fab51c%22%2C%22timestamp%22%3A%221753865915126%22%2C%22callbackUrl%22%3A%22https%3A%2F%2Fapi.reclaimprotocol.org%2Fapi%2Fsdk%2Fcallback%3FcallbackId%3D201cf943f0%22%2C%22context%22%3A%22%7B%5C%22contextAddress%5C%22%3A%5C%220x0%5C%22%2C%5C%22contextMessage%5C%22%3A%5C%22sample%20context%5C%22%7D%22%2C%22parameters%22%3A%7B%7D%2C%22redirectUrl%22%3A%22%22%2C%22acceptAiProviders%22%3Afalse%2C%22sdkVersion%22%3A%22js-4.1.0%22%2C%22jsonProofResponse%22%3Afalse%7D
      // copy the /verify/?template= 
      const template = requestUrl.split('/verify/?template=')[1]
      const finalUrl = `${window.location.origin}/verify/?template=${template}`
      window.open(finalUrl, '_blank');
    }
  };

  return (
    <div style={{ 
      padding: '40px 20px', 
      textAlign: 'center',
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      {/* App Logo */}
    <h1 
        style={{}}>
            Reclaim Protocol
        </h1>

      {/* Main Message */}
      <h1 style={{ 
        fontSize: '20px', 
        fontWeight: '600', 
        color: '#333',
        margin: '0 0 16px 0',
        lineHeight: '1.4',
        maxWidth: '300px'
      }}>
        Android Intent
      </h1>

      <p style={{ 
        fontSize: '14px', 
        color: '#666',
        margin: '0 0 32px 0',
        maxWidth: '280px',
        lineHeight: '1.5'
      }}>
        {requestUrl 
          ? 'Ready to verify your data with Reclaim'
          : 'Start verification process to prove your data'
        }
      </p>

      {/* Action Button */}
      {!requestUrl ? (
        <button 
          onClick={getVerificationReq}
          style={{
            padding: '16px 24px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            minWidth: '200px',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
        >
          Start Verification
        </button>
      ) : (
        <div style={{ textAlign: 'center' }}>
          {isMobile ? (
            <button
              onClick={handleMobileCTA}
              style={{
                padding: '16px 24px',
                fontSize: '16px',
                fontWeight: '600',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                minWidth: '200px',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
            >
              Open Link
            </button>
          ) : (
            <div>
              {!qrCodeUrl ? (
                <button
                  onClick={generateQRCode}
                  style={{
                    padding: '16px 24px',
                    fontSize: '16px',
                    fontWeight: '600',
                    backgroundColor: '#17a2b8',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    minWidth: '200px',
                    transition: 'background-color 0.2s',
                    marginBottom: '16px'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#138496'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#17a2b8'}
                >
                  Show QR Code
                </button>
              ) : (
                <div style={{ marginBottom: '16px' }}>
                  <img 
                    src={qrCodeUrl} 
                    alt="QR Code" 
                    style={{ 
                      border: '1px solid #ddd', 
                      borderRadius: '8px',
                      padding: '8px',
                      backgroundColor: 'white',
                      maxWidth: '200px'
                    }}
                  />
                </div>
              )}
              <button
                onClick={handleMobileCTA}
                style={{
                  marginLeft: "10px",
                  padding: '16px 24px',
                  fontSize: '16px',
                  fontWeight: '600',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  minWidth: '200px',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
              >
                Open Link
              </button>
            </div>
          )}
        </div>
      )}

      {/* Success State */}
      {proofs && proofs.length > 0 && (
        <div style={{ 
          marginTop: '24px',
          padding: '16px',
          backgroundColor: '#d4edda',
          borderRadius: '8px',
          border: '1px solid #c3e6cb',
          maxWidth: '300px'
        }}>
          <h3 style={{ 
            color: '#155724', 
            margin: '0 0 8px 0',
            fontSize: '16px'
          }}>
            ✅ Verification Complete
          </h3>
          <p style={{ 
            color: '#155724',
            margin: '0',
            fontSize: '14px'
          }}>
            Your data has been verified successfully
          </p>
        </div>
      )}

      {/* Small Info Text */}
    </div>
  );
}

export default HomePage;